import { render } from "./DeliveryList.vue?vue&type=template&id=8baea032&scoped=true"
import script from "./DeliveryList.vue?vue&type=script&lang=js"
export * from "./DeliveryList.vue?vue&type=script&lang=js"

import "./DeliveryList.vue?vue&type=style&index=0&id=8baea032&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8baea032"]])

export default __exports__